import { BaseEntity } from '../base-entity';
import { CardBrandType } from '../students/credit-card-tokens/credit-card-token-entity';

export enum AccountingDocType {
  RECEIPT = 'receipt', // קבלה
  RECEIPT_REFUND = 'receipt_refund', // קבלת זיכוי
  BILL = 'bill', // חשבון
  INVOICE = 'invoice', // חשבונית
  DONATION_RECEIPT = 'donation_receipt', // תרומה
  CASH_WITHDRAWAL = 'cash_withdrawal', // שובר משיכה מקופה
}

export interface AccountingDocumentBranchSummary {
  branchId: number;
  branchName: string;
}

export interface AccountingDocumentEntity extends BaseEntity {
  id: number;
  docType: AccountingDocType;
  parentDocumentId: number | null;
  parentDocNumber?: number | null;
  docNumber: number;
  amount: number;
  userPaymentId: number | null;
  crmPaymentId: number | null;
  crmBillId: number | null;
  fileUrl: string;
  subject: string | null;
  creditCardLast4?: string | null;
  creditCardBrand?: CardBrandType | null;
  creditCardNumInstallments?: number | null;
  branches?: AccountingDocumentBranchSummary[];
}
